import { lazy } from "react";

const CallRecentVisitPage = lazy(() => import("./pages/CallRecentVisitPage"));

// REACTIVADO EN PRODUCCIÓN (2026-10-01, pedido del usuario): se retiró el gate
// por entorno CALL_RECENT_VISIT_ENABLED del 2026-09-30. El acceso lo gobierna
// el RBAC de /call-recent-visit (hereda call_center), como el resto del
// Contact Center.
export const callRecentVisitRoutes = [
  { path: "/call-recent-visit", element: <CallRecentVisitPage /> },
];
